// removed by extract-text-webpack-plugin
module.exports = {"table":"DayPicker-table","calendarTd":"DayPicker-calendarTd","prevNextDays":"DayPicker-prevNextDays","weekDays":"DayPicker-weekDays"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdatepicker/DayPicker.scss
// module id = 109
// module chunks = 0